export default __webpack_public_path__ + "static/media/official-logo.4dce7ec6.png";